import React from 'react';
import UserAvatar from 'react-user-avatar';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
} from 'reactstrap';
import {
  Link,
  withRouter,
  RouteComponentProps,
  matchPath,
} from 'react-router-dom';
import './index.css';
import { authContext } from '../../../config/adal';
import { usePractitioner } from '../../../contexts/practitioner';

const ProfileButtonComponnet = ({
  isAdmin,
  name,
  organizationId,
}: {
  isAdmin?: boolean;
  name: string;
  organizationId?: string;
}) => (
  <UncontrolledDropdown nav inNavbar className="dropdown-button">
    <DropdownToggle nav>
      <Row noGutters>
        <Col>
          <UserAvatar
            size="32"
            name={name.toUpperCase()}
            className="dropdown-profile-avatar"
          />
        </Col>
        <Col className="dropdown-col">
          <span className="dropdown-profile-text">Profile</span>
        </Col>
      </Row>
    </DropdownToggle>
    <DropdownMenu right>
      <DropdownItem header>Profile</DropdownItem>
      <DropdownItem tag={Link} to="/profile">
        View Profile
      </DropdownItem>
      <DropdownItem tag={Link} to="/organization">
        Change Organization
      </DropdownItem>
      <DropdownItem divider />
      {isAdmin ? (
        <>
          <DropdownItem header>Organization Admin</DropdownItem>
          <DropdownItem
            tag={Link}
            disabled={!organizationId}
            to={`/organization/${organizationId}/practitioner`}>
            Clinicians
          </DropdownItem>
          <DropdownItem tag={Link} to="/report">
            Reports
          </DropdownItem>
          <DropdownItem divider />
        </>
      ) : null}
      <DropdownItem
        onClick={() => {
          authContext.logOut();
        }}>
        Logout
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

const ProfileButton = withRouter((props: RouteComponentProps<{}>) => {
  const match = matchPath<{ organizationId: string }>(props.location.pathname, {
    path: '/organization/:organizationId',
  });
  const { getDisplayName, getRoles } = usePractitioner();
  return (
    <ProfileButtonComponnet
      organizationId={match ? match.params.organizationId : undefined}
      isAdmin={getRoles().some(
        role => role.code === 'ict' || role.code === 'researcher',
      )}
      name={getDisplayName()}
    />
  );
});

export default ProfileButton;
